<template>
    <div v-loading="loading">
        <zm-button type="primary" plain @click="fetchData" size="small">Refresh</zm-button>
        <zm-form>
            <zm-form-item label="isCompleted">
                <i :class="{'zm-icon-ok':list.isCompleted,'zm-icon-close':!list.isCompleted}"></i>
            </zm-form-item>
            <zm-form-item label="expandTotalCount">{{list.expandTotalCount}}</zm-form-item>
            <zm-form-item label="pendingCount">{{list.pendingCount}}</zm-form-item>
            <zm-form-item label="successCount">{{list.successCount}}</zm-form-item>
            <zm-form-item label="verifyTotalCount">{{list.verifyTotalCount}}</zm-form-item>
        </zm-form>
        <zm-table v-if="list.pendingResult.length"
        :data="list.pendingResult.slice((pendingPagable.num - 1) * pendingPagable.size,
        pendingPagable.num * pendingPagable.size)">
            <zm-table-column label="pending">
                <!-- eslint-disable-next-line -->
                <template slot="header" slot-scope="scope">
                    Pending({{list.pendingCount}})
                </template>
            <zm-table-column prop="topicName" label="topicName"></zm-table-column>
            <zm-table-column prop="status" label="status"></zm-table-column>
            <zm-table-column prop="topicUrl" label="topicUrl"></zm-table-column>
            <zm-table-column prop="channels" label="channels"></zm-table-column>
            <zm-table-column prop="expandChannels" label="expandChannels"></zm-table-column>
            <zm-table-column prop="oldChannels" label="oldChannels"></zm-table-column>
            <zm-table-column prop="factor" label="factor"></zm-table-column>
            <zm-table-column prop="internal" label="internal">
                <template slot-scope="scope">
                    <i :class="{'zm-icon-ok':scope.row.internal,'zm-icon-close':!scope.row.internal}"></i>
                </template>
            </zm-table-column>
            <zm-table-column prop="lastExpandModifiedTime" label="lastExpandModifiedTime" :formatter="setTime"></zm-table-column>
            </zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap" v-if="list.pendingResult.length">
            <zm-pagination
                :current-page.sync="pendingPagable.num"
                :page-size="pendingPagable.size"
                layout="total, prev, pager, next, jumper"
                :total="list.pendingResult.length">
            </zm-pagination>
        </div>
        <zm-table v-if="list.successResult.length"
        :data="list.successResult.slice((successPagable.num - 1) * successPagable.size,
        successPagable.num * successPagable.size)">
            <zm-table-column label="success">
                <!-- eslint-disable-next-line -->
                <template slot="header" slot-scope="scope">
                    Success({{list.successCount}})
                </template>
            <zm-table-column prop="topicName" label="topicName"></zm-table-column>
            <zm-table-column prop="status" label="status"></zm-table-column>
            <zm-table-column prop="topicUrl" label="topicUrl"></zm-table-column>
            <zm-table-column prop="channels" label="channels"></zm-table-column>
            <zm-table-column prop="expandChannels" label="expandChannels"></zm-table-column>
            <zm-table-column prop="oldChannels" label="oldChannels"></zm-table-column>
            <zm-table-column prop="factor" label="factor"></zm-table-column>
            <zm-table-column prop="internal" label="internal">
                <template slot-scope="scope">
                    <i :class="{'zm-icon-ok':scope.row.internal,'zm-icon-close':!scope.row.internal}"></i>
                </template>
            </zm-table-column>
            <zm-table-column prop="lastExpandModifiedTime" label="lastExpandModifiedTime" :formatter="setTime"></zm-table-column>
            </zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap" v-if="list.successResult.length">
            <zm-pagination
                :current-page.sync="successPagable.num"
                :page-size="successPagable.size"
                layout="total, prev, pager, next, jumper"
                :total="list.successResult.length">
            </zm-pagination>
        </div>
    </div>
</template>
<script>
import { verifyChannel } from '../../api/index'
export default {
    name: 'verifyRes',
    props: ['data', 'verifyForm'],
    data () {
        return {
            list: null,
            loading: false,
            pendingPagable: {
                size: 10,
                num: 1
            },
            successPagable: {
                size: 10,
                num: 1
            }
        }
    },
    created () {
        this.list = this.data
    },
    watch: {
        data () {
            this.list = this.data
        }
    },
    methods: {
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            return new Date(parseInt(time)).toLocaleString()
        },
        fetchData () {
            const { channelId, expandTotalCount } = this.verifyForm
            const data = { channelId, expandTotalCount }
            this.loading = true
            verifyChannel(data).then(response => {
                this.list = response
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
